import PropTypes from "prop-types";

/**
 * PropTypes for Navigation component
 *
 * @property {boolean} [toggledMenu] - Whether menu is toggled/expanded
 * @property {boolean} [isMouseOver] - Whether mouse is hovering over navigation
 * @property {function} [onClose] - Close handler callback
 */
export const navigationPropTypes = {
  toggledMenu: PropTypes.bool,
  isMouseOver: PropTypes.bool,
  onClose: PropTypes.func,
};
